import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { CustomToaster } from '../../BaseUI';
import Layout from './Layout';

const client = new QueryClient();

const Gift = ({ offer }) => {
  return (
    <QueryClientProvider client={client}>
      <CustomToaster />
      <Layout offer={offer} />
    </QueryClientProvider>
  );
};

export default Gift;
